import axios from "axios"
export function sendUnderReviewEmail(email, fname, token   ) {
    return axios.post(process.env.REACT_APP_API_URL + '/sendApplicationUnderReviewEmail', { email: email, fname: fname }, {
        headers: {
            'Authorization': `${token}`
    }});
}